import { isEmpty } from 'lodash'
import { TripType } from '../components/transpais/enums'

/**
 * Verifica si el viaje es sencillo.
 * @param {Object} bookingTripConfig - Configuración del viaje.
 * @returns {boolean} - Verdadero si el viaje es sencillo.
 */
export const isSingleTrip = (bookingTripConfig) => {
  return bookingTripConfig.type === TripType.single
}

/**
 * Verifica si el viaje es redondo y se están seleccionando los asientos de ida.
 * @param {Object} bookingTripConfig - Configuración del viaje.
 * @param {Object} bookingReturningTrip - Información del viaje de regreso.
 * @returns {boolean} - Verdadero si es redondo y se están seleccionando los asientos de ida.
 */
export const isRoundTripDeparture = (bookingTripConfig, bookingReturningTrip) => {
  return bookingTripConfig.type === TripType.round && isEmpty(bookingReturningTrip)
}

/**
 * Verifica si el viaje es redondo y se están seleccionando los asientos de regreso.
 * @param {Object} bookingTripConfig - Configuración del viaje.
 * @param {Object} bookingReturningTrip - Información del viaje de regreso.
 * @returns {boolean} - Verdadero si es redondo y se están seleccionando los asientos de regreso.
 */
export const isRoundTripReturn = (bookingTripConfig, bookingReturningTrip) => {
  return bookingTripConfig.type === TripType.round && !isEmpty(bookingReturningTrip)
}

/**
 * Verifica si el viaje es redondo y se está seleccionando el viaje de ida.
 * @param {Object} bookingTripConfig - Configuración del viaje.
 * @param {Object} bookingDepartureTrip - Información del viaje de ida.
 * @returns {boolean} - Verdadero si es redondo y se está seleccionando el viaje de ida.
 */
export const isSelectingRoundTripDeparture = (bookingTripConfig, bookingDepartureTrip, fareList) => {
  // Verificar si el viaje es redondo y si aún faltan pasajeros por seleccionar
  return (
    bookingTripConfig.type === TripType.round &&
    isEmpty(bookingDepartureTrip) &&
    !isEmpty(fareList) // Verificar si aún faltan pasajeros por seleccionar
  )
}

/**
 * Verifica si el viaje es redondo y se está seleccionando el viaje de regreso.
 * @param {Object} bookingTripConfig - Configuración del viaje.
 * @param {Object} bookingDepartureTrip - Información del viaje de ida.
 * @param {Object} bookingReturningTrip - Información del viaje de regreso.
 * @param {Array} passengers - Lista de pasajeros.
 * @returns {boolean} - Verdadero si es redondo y se está seleccionando el viaje de regreso.
 */
export const isSelectingRoundTripReturn = (bookingTripConfig, bookingDepartureTrip, bookingReturningTrip, passengers) => {
  return (
    bookingTripConfig.type === TripType.round &&
    !isEmpty(bookingDepartureTrip) &&
    isEmpty(bookingReturningTrip) &&
    !isEmpty(passengers)
  )
}

/**
 * Filtra los fares disponibles según la cantidad máxima permitida y los pasajeros seleccionados.
 * @param {Array} fareList - Lista de fares disponibles.
 * @param {Object} countFares - Configuración de la cantidad máxima permitida por fareId.
 * @param {Array} selected - Lista de pasajeros seleccionados.
 * @returns {Array} - Lista de fares filtrados.
 */
// export const filterFares = (fareList, countFares, selected) => {
//   // Crear un objeto para contar cuántos pasajeros hay por fareId
//   const passengerCount = selected.reduce((acc, passenger) => {
//     if (passenger.fareId) {
//       acc[passenger.fareId] = (acc[passenger.fareId] || 0) + 1;
//     }
//     return acc;
//   }, {});

//   // Filtrar la lista estática
//   return fareList.filter((fare) => {
//     // Verificar si el fareId está en la configuración
//     if (countFares.hasOwnProperty(fare._id)) {
//       // Obtener la cantidad máxima permitida desde la configuración
//       const maxQuantity = countFares[fare._id];
//       // Obtener la cantidad actual de pasajeros registrados para este fareId
//       const currentQuantity = passengerCount[fare._id] || 0;
//       // Mostrar solo si aún no se ha alcanzado la cantidad máxima
//       return currentQuantity < maxQuantity;
//     }
//     return false; // Si no está en la configuración, no se muestra
//   });
// };
export const filterFares = (fareList, countFares, filteredSelected) => {
  // Crear un objeto para contar cuántos pasajeros hay por fareId
  const passengerCount = filteredSelected.reduce((acc, passenger) => {
    if (passenger.fareId) {
      acc[passenger.fareId] = (acc[passenger.fareId] || 0) + 1;
    }
    return acc;
  }, {});

  // Filtrar la lista estática
  return fareList.filter((fare) => {
    // Verificar si el fareId está en la configuración
    if (countFares.hasOwnProperty(fare._id)) {
      // Obtener la cantidad máxima permitida desde la configuración
      const maxQuantity = countFares[fare._id];
      // Obtener la cantidad actual de pasajeros registrados para este fareId
      const currentQuantity = passengerCount[fare._id] || 0;
      // Mostrar solo si aún no se ha alcanzado la cantidad máxima
      return currentQuantity < maxQuantity;
    }
    return false; // Si no está en la configuración, no se muestra
  });
};

/**
 * Formatea fecha y hora sin usar Date para evitar desfases de zona horaria.
 * dateStr: 'YYYY-MM-DD', timeStr: 'HH:mm' -> 'dd/MM/yyyy hh:mm am/pm'
 * @param {string} dateStr
 * @param {string} timeStr
 * @returns {string}
 */
export const formatDateForBooking = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return ''
  const [y, m, d] = dateStr.split('-').map(Number)
  let [hh, mm] = timeStr.split(':').map(Number)
  const ampm = hh >= 12 ? 'pm' : 'am'
  const hh12 = ((hh + 11) % 12) + 1
  const dd = String(d).padStart(2, '0')
  const MM = String(m).padStart(2, '0')
  return `${dd}/${MM}/${y} ${String(hh12)}:${String(mm).padStart(2, '0')} ${ampm}`
}